exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#test-drive-popup{position:fixed;z-index:101;padding-top:100px;left:0;top:0;right:0;bottom:0;overflow:auto;background-color:rgba(0,0,0,.7)}#test-drive-popup #unit-video{margin:33px auto;width:calc(100% - 46px)}#test-drive-popup #unit-video video{max-height:510px!important}#test-drive-popup .test-drive-popup__content{background-color:#fefefe;margin:auto;padding:24px;border:1px solid #888;width:80%}#test-drive-popup .test-drive-popup__content .unit-wrapper{padding:0}#test-drive-popup .test-drive-popup__close{color:#aaa;float:right;font-size:28px;font-weight:700}#test-drive-popup .test-drive-popup__close:focus,#test-drive-popup .test-drive-popup__close:hover{color:#000;text-decoration:none;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/popups/dashboard/test-drive-popup/test-drive-popup.scss
// module id = 1498
// module chunks = 0